export const getLogoFilename = (provider) => {
    if (!provider) return '../ecommerce/product-image-placeholder.png'
    if (provider === 'maas') return 'acm.png'
    return `${provider}.png`
}